import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

import { COMN_SF_LPCO_SRCH, COMN_SG_LPCO_LIST_HEAD, COMN_SG_LPCO_LIST_BODY } from "@/tz/go/egaz/osci/lpco/cfgn/comn";

/*
 *  LPCO FEE Settings
 * !== LPCO FEE Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/cfgn/fee`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/fee`,
    nodes: [
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_CFGN" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO_APP_SETT" },
        { path: "/lpco/cfgn/fee/osci0203021s", label: "T_FEE_SETT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0203021s: `${BASE.path}/osci0203021s`, // Register LPCO FEE information   !== LPCO FEE 등록  ==!
    osci0203022q: `${BASE.path}/osci0203022q`, // Register LPCO FEE List  !== LPCO FEE 목록  ==!
    osci0203023s: `${BASE.path}/osci0203023s`, // Register LPCO FEE Detail  !== LPCO FEE 상세  ==!
    osci0203024s: `${BASE.path}/osci0203024s`, // LPCO FEE Modification  !== LPCO FEE 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    /* LPCO FEE list inquiry !== LPCO FEE 목록 조회 ==! */
    getLpcoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getFeeInfo: (feeImpsCtraId: any) => {
        return api.get(`${BASE.api}/${feeImpsCtraId}`);
    },
    /* LPCO detailed inquiry !== LPCO FEE 상세 조회 ==! */
    getLpcoCnptDtl: async (appFmId: any) => {
        return await api.get(`${BASE.api}/${appFmId}`);
    },
    /* Register LPCO information !== LPCO FEE 등록 ==! */
    createFeeInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    /* Edit LPCO information !== LPCO FEE 수정 ==! */
    updateFeeInfo: (feeImpsCtraId: any, data: any) => {
        return api.put(`${BASE.api}/${feeImpsCtraId}`, {
            ...data,
        });
    },
    /* Delete LPCO information !== LPCO FEE 삭제 ==! */
    deleteFeeInfo: (feeImpsCtraId: any) => {
        return api.delete(`${BASE.api}/${feeImpsCtraId}`, {});
    },
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */
/**
 * Component Setting > Register LPCO FEEs
 */
// LPCO FEE Schema !== LPCO FEE ==!
export const SF_LPCO_INFO_U: TFormSchema = {
    id: "form_LpcoInfoU",
    schema: {
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA */,
        appCdNo: { type: "select", label: "L_LPCO", required: true, edit: true } /* Application Code */,
        appNm: { type: "text", label: "L_APP_NM", required: true } /* Application Name */,
        feeImpsTpCd: {
            type: "select",
            label: "L_FEE_TP",
            required: true,
            area: "comnCd",
            comnCd: "OSC0123",
        } /* Fee Type */,
        feeRuleNm: { type: "text", label: "L_FEE_RULE_NM", required: true, maxLength: 150 } /* Fee Rule Name */,
        feeDesc: { type: "textarea", label: "L_FEE_DESC", maxLength: 4000 } /* Fee Description */,
        feeImpsCtraCd: {
            type: "select",
            label: "L_FEE_IMPS_CTRA",
            area: "comnCd",
            comnCd: "OSC0135",
            required: true,
        } /* Fee charging criteria */,
        feeImpsCndtCd: {
            type: "select",
            label: "L_FEE_IMPS",
            required: true,
            area: "comnCd",
            comnCd: "OSC0136",
        } /* Fee charging conditions */,
        srvcFeeCurrCd: {
            type: "select",
            label: "L_CURR_CD",
            area: "comnCd",
            comnCd: "OSC0060",
            required: true,
        } /* Fee charging conditions */,

        vldStrtDt: {
            type: "date",
            label: "L_VLD_STRT_DT",
            required: true,
        } /* Valid Start Date */,
        vldEndDt: {
            type: "date",
            label: "L_VLD_END_DT",
            required: true,
        } /* Valid End Date */,
        feePrgmNm: { type: "text", label: "L_FUNC_NM", required: true } /* Function Name */,
        baseFee: {
            type: "number",
            label: "L_BASE_FEE_AMT",
            defaultValue: 0,
            maxLength: 22,
            decimalScale: 4,
        } /* basePrice*/,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
        lpcoAplyTpCd: {
            type: "select",
            label: "L_LPCO_APLY_TP",
            area: "comnCd",
            comnCd: "OSC0143",
            edit: true,
            required: true,
        },
        cmbiBllYn: {
            type: "select",
            label: "L_CMBI_BLL_YN",
            area: "comnCd",
            comnCd: "OSC0063",
            viewType: "label",
            edit: false,
        },
    },
};

export const SF_LPCO_INFO_R: TFormSchema = {
    id: "form_LpcoInfoR",
    schema: {
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA */,
        appCdNo: { type: "select", label: "L_LPCO", required: true, edit: true },
        appNm: { type: "text", label: "L_APP_NM", edit: false },
        feeImpsTpCd: {
            type: "select",
            label: "L_FEE_TP",
            area: "comnCd",
            comnCd: "OSC0123",
            edit: false,
        } /* Fee Type */,
        feeRuleNm: { type: "text", label: "L_FEE_RULE_NM", edit: false } /* Fee Rule Name */,
        feeDesc: { type: "textarea", label: "L_FEE_DESC", edit: false } /* Fee Description */,
        feeImpsCtraCd: {
            type: "select",
            label: "L_FEE_IMPS_CTRA",
            area: "comnCd",
            comnCd: "OSC0135",
            edit: false,
        } /* Fee charging criteria */,
        feeImpsCndtCd: {
            type: "select",
            label: "L_FEE_IMPS",
            area: "comnCd",
            comnCd: "OSC0136",
            edit: false,
        } /* Fee charging conditions */,
        srvcFeeCurrCd: {
            type: "select",
            label: "L_CURR_CD",
            area: "comnCd",
            comnCd: "OSC0060",
            edit: false,
        } /* Fee charging conditions */,

        vldStrtDt: {
            type: "date",
            label: "L_VLD_STRT_DT",
            edit: false,
        } /* Valid Start Date */,
        vldEndDt: {
            type: "date",
            label: "L_VLD_END_DT",
            edit: false,
        } /* Valid End Date */,
        feePrgmNm: { type: "text", label: "L_FUNC_NM", edit: false } /* Function Name */,

        baseFee: { type: "number", label: "L_BASE_FEE_AMT", edit: false } /* basePrice*/,

        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
        lpcoAplyTpCd: {
            type: "select",
            label: "L_LPCO_APLY_TP",
            area: "comnCd",
            comnCd: "OSC0143",
            edit: false,
            viewType: "label",
        },
        cmbiBllYn: {
            type: "select",
            label: "L_CMBI_BLL_YN",
            area: "comnCd",
            comnCd: "OSC0063",
            viewType: "label",
            edit: false,
        },
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

/**
 * Component Setting > LPCO LIST
 */
// LPCO FEE Search Schema !== LPCO FEE Search  ==!
export const SF_LPCO_SRCH: TFormSchema = {
    id: "form_LpcoSrch",
    schema: {
        ...COMN_SF_LPCO_SRCH,
        srchFeeRuleNm: {
            type: "text",
            label: "L_FEE_RULE_NM",
        },
        srchFeeImpsTpCd: {
            type: "select",
            label: "L_FEE_TP",
            all: true,
            area: "comnCd",
            comnCd: "OSC0123",
        },
        srchLpcoAplyTpCd: {
            type: "select",
            label: "L_LPCO_APLY_TP",
            area: "comnCd",
            comnCd: "OSC0143",
            edit: true,
            all: true,
        },
    },
};

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_LIST_R: TGridSchema = {
    id: "grid_lpcoList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        ...COMN_SG_LPCO_LIST_HEAD,
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 80 }] } /* Use Yn */,
        { cells: [{ header: "L_LPCO_APLY_TP", binding: "lpcoAplyTpCd", width: 150 }] },
        { cells: [{ header: "L_FEE_RULE_NM", binding: "feeRuleNm", width: "*" }] },
        { cells: [{ header: "L_FEE_TP", binding: "feeImpsTpCd", width: 150 }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "vldStrtDt", width: 100 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "vldEndDt", width: 100 }] },
    ],
    body: [
        ...COMN_SG_LPCO_LIST_BODY,
        {
            cells: [
                {
                    binding: "useYn",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    type: "select",
                    viewType: "value",
                },
            ],
        },
        { cells: [{ binding: "lpcoAplyTpCd", area: "comnCd", comnCd: "OSC0143", type: "select", viewType: "label" }] },
        { cells: [{ binding: "feeRuleNm", align: "left" }] },
        {
            cells: [
                {
                    binding: "feeImpsTpCd",
                    align: "select",
                    area: "comnCd",
                    comnCd: "OSC0123",
                    type: "select",
                    viewType: "label",
                },
            ],
        },
        { cells: [{ binding: "vldStrtDt", type: "date", align: "center" }] },
        { cells: [{ binding: "vldEndDt", type: "date", align: "center" }] },
    ],
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO FEE Schema !== LPCO FEE ==!
export const SG_COND_PER_DOC_LIST: TGridSchema = {
    id: "grid_condPerDocList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [{ cells: [{ header: "L_AMT", binding: "feeDtlAmt", width: "*" }] } /* Amount */],
    body: [
        {
            cells: [
                {
                    binding: "feeDtlAmt",
                    align: "right",
                    type: "number",
                    required: true,
                    maxLength: 22,
                    decimalScale: 4,
                },
            ],
        },
    ],
};

// LPCO FEE Schema !== LPCO FEE ==!
export const SG_COND_PER_WG_FOB_LIST: TGridSchema = {
    id: "grid_condPerWgFobList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        { cells: [{ header: "L_PR_KG_FOB", binding: "feeDtlCtraValue", width: "*" }] } /* Per(KG or FOB) */,
        { cells: [{ header: "L_AMT", binding: "feeDtlAmt", width: "*" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "feeDtlCtraValue",
                    align: "right",
                    type: "number",
                    required: true,
                    maxLength: 20,
                    decimalScale: 4,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "feeDtlAmt",
                    align: "right",
                    type: "number",
                    required: true,
                    maxLength: 22,
                    decimalScale: 4,
                },
            ],
        },
    ],
};

export const SG_COND_RNGE_WG_FOB_LIST: TGridSchema = {
    id: "grid_condRngeWgFobList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 250,
    },
    head: [
        { cells: [{ header: "L_MIN_VAL", binding: "rngeMinValue", width: "*" }] } /* Per(KG or FOB) */,
        { cells: [{ header: "<= (Weight(KG) or FOB/CIF) <", binding: "rngeTxt", width: "*" }] },
        { cells: [{ header: "L_MAX_VAL", binding: "rngeMaxValue", width: "*" }] },
        { cells: [{ header: "L_AMT", binding: "feeDtlAmt", width: "*" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "rngeMinValue",
                    align: "right",
                    type: "number",
                    required: true,
                    maxLength: 20,
                    decimalScale: 4,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "rngeTxt",
                    align: "center",
                    type: "text",
                    required: false,
                    edit: false,
                    defaultValue: "<= (Weight(KG) or FOB/CIF) <",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "rngeMaxValue",
                    align: "right",
                    type: "number",
                    required: true,
                    maxLength: 20,
                    decimalScale: 4,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "feeDtlAmt",
                    align: "right",
                    type: "number",
                    required: true,
                    maxLength: 22,
                    decimalScale: 4,
                },
            ],
        },
    ],
};

export const SG_COND_PER_CNTR_LIST: TGridSchema = {
    id: "grid_condPerCntrList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        { cells: [{ header: "L_CNTR_SIZE", binding: "feeCntrSizeCd", width: "*" }] },
        { cells: [{ header: "L_PR", binding: "feeDtlCtraValue", width: "*" }] },
        { cells: [{ header: "L_AMT", binding: "feeDtlAmt", width: "*" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "feeCntrSizeCd",
                    align: "center",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0138",
                    all: false,
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "feeDtlCtraValue",
                    align: "right",
                    type: "number",
                    required: true,
                    edit: true,
                    maxLength: 20,
                    decimalScale: 4,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "feeDtlAmt",
                    align: "right",
                    type: "number",
                    required: true,
                    edit: true,
                    maxLength: 22,
                    decimalScale: 4,
                },
            ],
        },
    ],
};

export const SG_COND_PCT_FOB_LIST: TGridSchema = {
    id: "grid_condPerList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [{ cells: [{ header: "L_PCT", binding: "feeDtlCtraValue", width: "*" }] }],
    body: [
        {
            cells: [
                {
                    binding: "feeDtlCtraValue",
                    align: "right",
                    type: "number",
                    required: true,
                    maxLength: 7,
                    max: 100,
                    decimalScale: 4,
                },
            ],
        },
    ],
};

export const SG_COND_MAX_FOB_LIST: TGridSchema = {
    id: "grid_condPerList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        { cells: [{ header: "L_AMT_PCT_TP", binding: "feeDtlCtraTpCd", width: "*" }] },
        { cells: [{ header: "L_VALUE_PCT_USD", binding: "feeDtlCtraValue", width: "*" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "feeDtlCtraTpCd",
                    type: "select",
                    required: true,
                    area: "comnCd",
                    comnCd: "OSC0137",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "feeDtlCtraValue",
                    type: "number",
                    required: true,
                    align: "right",
                },
            ],
        },
    ],
};

// GFS Code List Schema !== GFS 코드 목록 ==!
export const SG_GFS_CD_LST: TGridSchema = {
    id: "grid_gfsCdList",
    options: {
        radio: true, // 라디오 버튼 보이기/숨기기 ( up/down/delete 대상 선택 )
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        { cells: [{ header: "L_GFS_CD", binding: "gfsCd", width: 200 }] } /* GFS Code */,
        { cells: [{ header: "L_GFS_DESC", binding: "gfsDesc", width: "*" }] } /* GFS Description */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "gfsCd",
                    align: "left",
                    type: "text",
                    required: true,
                    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
                    maxLength: 12,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "gfsDesc",
                    align: "left",
                    type: "text",
                    maxLength: 2000,
                },
            ],
        },
    ],
};
